<template>
  <div>


   
        <div id="dataTable" role="grid" aria-describedby="dataTable_info"
          style="overflow-y: hidden;">
          <div>
            <el-row style="margin-top:10px">
              <el-col :offset="1" :span="17" >
                <el-input v-model="searchText">
                </el-input>
              </el-col>
              <el-col :span="2">
                <el-button @click="OnSearchClick">搜索</el-button>
              </el-col>
            </el-row>
            <li style="padding: 15px;margin-top:15px; text-align: left" class="list-group-item">
              <img class="icon" src="../assets/icon.png">
              <span style="">
                <a style="font-size: 10px" href="javascript:;" @click="OpenPage({ 'id': -1 })">
                 {{$tt('查看全部☆All products')}} 
                </a>
              </span>
            </li>
            <li v-for="element in DataList" :key="element.name" style="padding: 15px; text-align: left"
              class="list-group-item">
              <img
                onerror="javascript:this.src='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNzUycHQiIGhlaWdodD0iNzUycHQiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDc1MiA3NTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiA8Zz4KICA8cGF0aCBkPSJtMjQ2LjQ4IDI2MC43OGMwIDE4LjMyOCAxNC44NzEgMzMuMTk5IDMzLjE5OSAzMy4xOTkgMTguMjM0IDAgMzMuMTAyLTE0Ljg3MSAzMy4xMDItMzMuMTk5IDAtMTguMjM0LTE0Ljg3MS0zMy4xMDItMzMuMTAyLTMzLjEwMi0xOC4zMjggMC0zMy4xOTkgMTQuODcxLTMzLjE5OSAzMy4xMDJ6bTQ1LjU1OSAwYzAgNi44NjcyLTUuNTM5MSAxMi40MDYtMTIuMzU5IDEyLjQwNi02Ljg2NzIgMC0xMi40MDYtNS41MzkxLTEyLjQwNi0xMi40MDYgMC02Ljc3MzQgNS41MzkxLTEyLjM1OSAxMi40MDYtMTIuMzU5IDYuNzY5NSAwIDEyLjM1OSA1LjU4OTggMTIuMzU5IDEyLjM1OXoiLz4KICA8cGF0aCBkPSJtMzQzLjIzIDQ0Mi4zLTIwLjc4OSAyMC43ODloMTMwLjE5YzUuNzMwNSAwIDEwLjM3MS00LjY0MDYgMTAuMzcxLTEwLjM3MXYtMTMwLjE5bC0yMC43ODkgMjAuNzg5djM0LjQzbC0xNS41MzUtMTguODk1LTE0LjcyNyAxNC43MjcgMzAuMjYyIDM2Ljg5MS0wLjAwMzkwNyAzMS44Mjh6Ii8+CiAgPHBhdGggZD0ibTQ3NC4zMiAyNDQuMi0xMS4yNy0yNS42Njh2LTIwLjY5NWMwLTUuNzMwNS00LjY0MDYtMTAuMzcxLTEwLjM3MS0xMC4zNzFoLTI1NC45M2MtNS43MzA1IDAtMTAuMzcxIDQuNjQwNi0xMC4zNzEgMTAuMzcxdjI1NC44OGMwIDUuNzMwNSA0LjY0MDYgMTAuMzcxIDEwLjM3MSAxMC4zNzFoNTcuNjM3bDIwLjc4OS0yMC43ODloLTY4LjA1NXYtMzkuMDdsMzIuMTU2LTQ4LjA3YzMuMTI1LTQuNTkzOCAxMC40NjUtNC41OTM4IDEzLjY0MSAwLjA5Mzc1bDIyLjA3IDMzLjA1NWMxLjgwMDggMi43OTMgNC44MzIgNC40MDYyIDguMDk3NyA0LjU5MzggMy41OTc3IDAuMjM4MjggNi40NDE0LTEuMjMwNSA4LjU3MDMtMy43NDIybDU5LjcxOS03Mi44MzJjMS40Njg4LTEuODAwOCAzLjgzNTktMi44Mzk4IDYuMzk0NS0yLjgzOThoMC4wOTM3NWMyLjQ2MDkgMCA0LjczNDQgMS4wNDMgNi4yMDMxIDIuODM5OGwxNi43NjYgMjAuMzYzIDE0LjcyNy0xNC43MjctMTUuNDM4LTE4LjgwMWMtNS4zOTg0LTYuNjI4OS0xMy40OTYtMTAuMzcxLTIyLjE2NC0xMC40NjVoLTAuMTQwNjJjLTguNjY4IDAtMTYuODU5IDMuNzQyMi0yMi4zMDUgMTAuMzcxbC01MS4wNTUgNjIuMDM1LTE0LjM5OC0yMS41Yy0xMC44OTEtMTYuMTAyLTM3LjEyOS0xNi4xMDItNDguMDItMC4wOTM3NWwtMTQuOTY1IDIyLjMwNXYtMTU3LjYxaDIzNC4xNHY2OC4wNTV6Ii8+CiAgPHBhdGggZD0ibTQ5NC43MyAyOTAuOC0xNS43MjMgMTUuNzIzIDYxLjUyIDEzOS45OS0yMTQuMzkgOTQuMDA0LTI0Ljc3LTU2LjM1NS0xNS43MjMgMTUuNzIzIDI1LjU3NCA1OC40ODhjMS43MDMxIDMuOTI5NyA1LjUzOTEgNi4yMDMxIDkuNTY2NCA2LjIwMzEgMS4zNzUgMCAyLjc5My0wLjIzODI4IDQuMDc0Mi0wLjgwNDY5bDIzMy41Ny0xMDIuMzljMi40NjA5LTEuMTM2NyA0LjUtMy4xNzE5IDUuNDkyMi01LjczMDUgMC45OTYwOS0yLjYwNTUgMC44OTg0NC01LjM5ODQtMC4xNDA2Mi03LjkxMDJ6Ii8+CiAgPHBhdGggZD0ibTU1Ni44MiAxNzcuODYtMzc4Ljk2IDM3OC45NmMtNC43ODEyIDQuNzgxMi00Ljc4MTIgMTIuNTUxIDAgMTcuMzMyIDIuNDE0MSAyLjQxNDEgNS41MzkxIDMuNTk3NyA4LjY2OCAzLjU5NzcgMy4xMjUgMCA2LjI5NjktMS4xODM2IDguNjY4LTMuNTk3N2wzNzguOTEtMzc4LjkxYzQuNzgxMi00Ljc4MTIgNC43ODEyLTEyLjU1MSAwLTE3LjMzMi00Ljc0MjItNC44MzItMTIuNTA4LTQuODMyLTE3LjI4OS0wLjA0Njg3NXoiLz4KIDwvZz4KPC9zdmc+Cg==';"
                class="icon" :src="element.icon">
              <span style="">
                <a style="font-size: 10px;" href="javascript:;" @click="OpenPage(element)">
                  {{ $tt(element.name) }}
                </a>
              </span>
            </li>
          </div>
        </div>


  </div>
</template>

<script>
import router from "../router/index";
import "../common/httphelper";
import swal from "sweetalert2";
import getRole from "../common/role";
import {
  AddProductCatlog,
  DeleteProductCatlog,
  GetProductCatlog,
  SortProductCatlog,
  UpdateProductCatlog,
} from "../common/httphelper";
import Swal from "sweetalert2";
import draggable from "vuedraggable";

export default {
  data() {
    return {
      searchText:'',
      DataList: [],
      role: {},
    };
  },
  methods: {

    OnSearchClick(){

      if(!this.searchText){
        Swal.fire('请输入搜索内容')
        return;
      }

      router.push({ name: "MobileProductInfo", query: { catlog: -2,value:this.searchText } });
    },

    OpenPage(item) {
      router.push({ name: "MobileProductInfo", query: { catlog: item.id } });
    },

    RefreshList() {
      GetProductCatlog().then((res) => {
        if (res.data.code == 20000) {
          this.DataList = res.data.data;
        }
      });
    },
    onEnd() {
      for (let n = 0; n < this.DataList.length; n++) {
        this.DataList[n].index = n;
      }
      let res = this.DataList.map((v) => {
        return {
          id: v.id,
          index: v.index,
        };
      });
      SortProductCatlog(res);
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  mounted() {
    this.RefreshList();
    this.role = getRole();
  },
};
</script>

<style scoped>
a {
  color: #4e73df;
  text-decoration: none;
  cursor: pointer;
  
}

.handle {
  float: left;
  margin-right: 15px;
  font-size: 18px;
  cursor: Move;
  line-height: 24px;
}

.icon {
  height: 50px;
  width: 50px;
}
</style>